<template>
  <div class="exam_left">
    <div class="left_wrap">
      <el-collapse style="overflow-y:auto;overflow-x:hidden;height:100%;" v-if="paperData !== null"
                   v-model="activeNames">
        <el-collapse-item v-for="(qitem,index) in leftData"
                          :title="`${ qitem.sectionAlias || qitem.sectionName}   (共${qitem.testPaperQuestionsList == null ? '' : qitem.testPaperQuestionsList.length}题)`"
                          :name="index" :key="index">
          <ul class="topic_wrap">
            <li v-bind:title="item.selected" v-if="qitem.orderSort === 0"
                :class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
                @click="setQuestion(item,item.id,qitem.testPaperQuestionsList,index1,item.questionId)"
                v-for="(item,index1) in qitem.testPaperQuestionsList" class="topic_num" :key="index1">{{index1+1}}
            </li>
            <li v-bind:title="item.selected" v-if="qitem.orderSort === 1"
                :class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
                @click="setQuestion(item,item.id,qitem.testPaperQuestionsList,index1,item.questionId)"
                v-for="(item,index1) in qitem.testPaperQuestionsList" class="topic_num" :key="index1">
              {{leftData[0].testPaperQuestionsList.length+index1+1}}
            </li>
            <li v-bind:title="item.selected" v-if="qitem.orderSort === 2"
                :class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
                @click="setQuestion(item,item.id,qitem.testPaperQuestionsList,index1,item.questionId)"
                v-for="(item,index1) in qitem.testPaperQuestionsList" class="topic_num" :key="index1">
              {{leftData[0].testPaperQuestionsList.length+leftData[1].testPaperQuestionsList.length+index1+1}}
            </li>
            <li v-bind:title="item.selected" v-if="qitem.orderSort === 3"
                :class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
                @click="setQuestion(item,item.id,qitem.testPaperQuestionsList,index1,item.questionId)"
                v-for="(item,index1) in qitem.testPaperQuestionsList" class="topic_num" :key="index1">
              {{leftData[0].testPaperQuestionsList.length+leftData[1].testPaperQuestionsList.length+leftData[2].testPaperQuestionsList.length+index1+1}}
            </li>
            <li v-bind:title="item.selected" v-if="qitem.orderSort === 4"
                :class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
                @click="setQuestion(item,item.id,qitem.testPaperQuestionsList,index1,item.questionId)"
                v-for="(item,index1) in qitem.testPaperQuestionsList" class="topic_num" :key="index1">
              {{leftData[0].testPaperQuestionsList.length+leftData[1].testPaperQuestionsList.length+leftData[2].testPaperQuestionsList.length+leftData[3].testPaperQuestionsList.length+index1+1}}
            </li>
            <li v-bind:title="item.selected" v-if="qitem.orderSort === 5"
                :class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
                @click="setQuestion(item,item.id,qitem.testPaperQuestionsList,index1,item.questionId)"
                v-for="(item,index1) in qitem.testPaperQuestionsList" class="topic_num" :key="index1">
              {{leftData[0].testPaperQuestionsList.length+leftData[1].testPaperQuestionsList.length+leftData[2].testPaperQuestionsList.length+index1+1}}
            </li>
            <li v-bind:title="item.selected" v-if="qitem.orderSort === 6"
                :class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
                @click="setQuestion(item,item.id,qitem.testPaperQuestionsList,index1,item.questionId)"
                v-for="(item,index1) in qitem.testPaperQuestionsList" class="topic_num" :key="index1">
              {{leftData[0].testPaperQuestionsList.length+leftData[1].testPaperQuestionsList.length+leftData[2].testPaperQuestionsList.length+index1+1}}
            </li>
            <li v-bind:title="item.selected" v-if="qitem.orderSort === 7"
                :class="[{active:num === item.id},{select:item.selected},{makeAnswer:item.makeAnswer}]"
                @click="setQuestion(item,item.id,qitem.testPaperQuestionsList,index1,item.questionId)"
                v-for="(item,index1) in qitem.testPaperQuestionsList" class="topic_num" :key="index1">
              {{leftData[0].testPaperQuestionsList.length+leftData[1].testPaperQuestionsList.length+leftData[2].testPaperQuestionsList.length+index1+1}}
            </li>
          </ul>
        </el-collapse-item>
        <div class="left_footer">
          <div class="not_do">
            <p></p>
            <p>未做</p>
          </div>
          <div class="do">
            <p></p>
            <p>已做</p>
          </div>
          <div class="current">
            <p></p>
            <p>当前</p>
          </div>
          <div class="select">
            <p></p>
            <p>待定</p>
          </div>
        </div>
      </el-collapse>
      <!--        <div class="student-information">-->
      <!--           <h1>考生信息</h1>-->
      <!--          <div v-if="paperData !== null" class="student_item">-->
      <!--            <img :src="paperData.stuInfo.photoShow" alt="">-->
      <!--            <div class="student_list">-->
      <!--              <div class="student_number"><span>考号：</span><span>{{paperData.stuInfo.examCardno}}</span></div>-->
      <!--              <div style="margin-top: 12px;" class="student_number"><span>姓名：</span><span>{{paperData.stuInfo.examStudentName}}</span></div>-->
      <!--              <div style="margin-top: 12px;" class="student_number"><span>性别：</span><span>{{paperData.stuInfo.sex}}</span></div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--&lt;!&ndash;          <h2>&ndash;&gt;-->
      <!--&lt;!&ndash;            <span class="h_left">考试科目：</span>&ndash;&gt;-->
      <!--&lt;!&ndash;            <span  v-if="paperData !== null" class="h_right">{{paperData.stuInfo.examSubjectName}}</span>&ndash;&gt;-->
      <!--&lt;!&ndash;          </h2>&ndash;&gt;-->
      <!--        </div>-->
    </div>


  </div>
</template>
<script>
  import * as api from "../../../../../api/testExamApi";
  import {moduleId} from "../../../../../store/modules/exam";
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';

  export default {
    name: "examLeft",
    data() {
      return {
        activeNames: [0, 1, 2, 3, 4],
        num: 0,
        activeData: null,
        switchData: null,
        examPaperId: 0
      };
    },
    created() {
      api.classQuery(this.$route.query.classId).then((result) => {
        if (result.code === "0") {
          localStorage.setItem("subjectId", result.data.subjectId);
          sessionStorage.setItem("courseName", result.data.courseName);
          let obj = {
            "paperId": this.$route.query.paperId,
            "subjectId": result.data.subjectId,
            "classId": this.$route.query.classId,
            "courseId": this.$route.query.id,
            "catalogId": this.$route.query.catalogId,
            "paperCode": this.$route.query.paperCode,
            "type": this.$route.query.type,
            "examId": this.$route.query.examId
          }
          this.selectTest(obj).then((result) => {
            this.examPaperId = result.data.examPaperId
            if (result.code === "1") {
              this.$router.push({
                path: '/switch/test/stupreview',
                query: {
                  id: this.$route.query.id,
                  classId: this.$route.query.classId,
                  userId: sessionStorage.getItem('userId'),
                  paperId: this.$route.query.paperId,
                  finishFlag: 0
                }
              });
            } else if (result.code === "2") {
              this.$messageError(result.msg);
            } else if (result.code === "6") {
              this.$messageError(result.msg);
            }
            if (result.data.paperStructure !== "") {
              this.SET_LEFT_DATA(JSON.parse(result.data.paperStructure)[0].testPaperPartsList[0].testPaperSectionsList);
            } else {
              this.SET_LEFT_DATA(null);
              this.$messageError("试卷为空！");
            }
          });
        } else if (result.code === "2" || result.code === "2") {
          this.$messageError(result.msg);
        }
      })


    },
    computed: {
      ...mapState(moduleId, {
        paperData: state => state.paperData,
        //leftData:state => state.paperData === null ? null : JSON.parse(state.paperData.paperStructure)[0].testPaperPartsList[0].testPaperSectionsList,
        leftData: state => state.leftData,
        questionData: state => state.questionData,
        answer: state => state.paperData === null ? null : state.paperData.alreadyQuestion,
        success: state => state.success,
        makeAnswerSelect: state => state.paperData === null ? null : state.paperData.remarkQuestion,
        makeAnswerSelectEd: state => state.makeAnswer,
      }),
    },
    watch: {
      leftData(newVal) {
        /**
         * 实操题和组合题拼接
         */
        newVal.map((item) => {
          if (item.testPaperQuestionsList) {
            let questionsList = [];
            item.testPaperQuestionsList.forEach((data, index1) => {

              if (data.questionDto.internalTypeId === 6) {
                data.questionDto.childQuestions.forEach((result, index) => {
                  let obj = {
                    id: result.id,
                    orderSort: index1 + index,
                    questionDto: result,
                    questionContent: data.questionDto.questionContent,
                    questionId: result.id,
                    score: JSON.parse(data.scoreDistribution)[result.id],
                  }
                  questionsList.push(obj);
                })
              }else{
                questionsList.push(data);
              }
            });

            item.testPaperQuestionsList = questionsList;
          }

        });
        console.log('--newVal--', newVal)

        // 去掉组合题
        // newVal.map((item) => {
        //   if (item.testPaperQuestionsList) {
        //     item.testPaperQuestionsList.forEach((data, index, arr) => {
        //       if (data.questionDto.internalTypeId === 6) {
        //         arr.splice(index, 1);
        //       }
        //     });
        //   }
        // });

        //乱序题号
        if (this.paperData.isQuestionOrder === 1) {
          newVal.map((item) => {
            item.testPaperQuestionsList.sort(function (data) {
              //组合题不乱序
              if (item.internalTypeId === 6) {
                return false;
              } else {
                return Math.random() - 0.5;
              }
              ;

            });
          });
        }
        // console.log(newVal);

        this.answer.forEach((item) => {
          this.leftData.forEach((data) => {
            if (data.testPaperQuestionsList) {
              data.testPaperQuestionsList.forEach((result) => {
                if (result.questionId === item.questionId) {
                  result.selected = true;
                }
              })
            }

          })

        })
        //默认显示第一试题
        this.num = newVal === null ? 0 : newVal[0].testPaperQuestionsList[0].id;
        this.SET_QUESTION_DATA(newVal[0].testPaperQuestionsList[0]);
        let questionId = newVal === null ? 0 : newVal[0].testPaperQuestionsList[0].questionId;
        //显示第一道题的答案
        let obj = {
          "paperId": this.$route.query.paperId,
          "questionId": questionId,
          "userId": sessionStorage.getItem('userId'),
          "classId": this.$route.query.classId,
          "examPaperId": this.examPaperId
        };
        this.preAnswer(obj);


        //切换上一题，下一题数据
        let switchArray = [];
        newVal.forEach((item) => {
          item.testPaperQuestionsList.forEach((data) => {
            data.sectionPrompt = item.sectionPrompt;
            data.sectionName = item.sectionName;
            switchArray.push(data);
          })
        });
        let object = {
          data: switchArray,
          index: 0
        };
        this.switchData = object;
        this.SET_PAPER_LIST(object);


      },
      questionData(val) {
        this.num = val.id;
      },
      answer(val) {

        // val.forEach((item)=>{
        //   console.log(this.leftData);
        //   if(this.leftData !== null){
        //     this.leftData.forEach((data)=>{
        //       data.testPaperQuestionsList.forEach((result)=>{
        //         console.log(result.questionId);
        //         console.log(item.questionId);
        //         if(result.questionId === item.questionId){
        //           result.selected = true;
        //         }
        //       })
        //     })
        //   }
        //
        // })

      },
      success(val) {
        if (val !== null) {
          if (val.status === 1) {//标记已做
            this.leftData.forEach((item) => {
              item.testPaperQuestionsList.forEach((data) => {
                if (data.questionId === val.questionId) {
                  data.selected = true;
                }
              })
            });
          } else if (val.status === 0) {//取消标记
            this.leftData.forEach((item) => {
              item.testPaperQuestionsList.forEach((data) => {
                if (data.questionId === val.questionId) {
                  data.selected = false;
                }
              })
            });
          }

        }
      },
      makeAnswerSelect(val) {

        let that = this;
        setTimeout(() => {
          //  console.log(that.leftData);
          //  console.log(val);
          val.forEach((item) => {
            that.leftData.forEach((data) => {
              data.testPaperQuestionsList.forEach((result) => {
                if (result.questionId === item) {
                  result.makeAnswer = true;
                }
              })
            })
          })
          that.$forceUpdate()
        }, 500)


      },
      makeAnswerSelectEd(val) {

        this.leftData.forEach((item) => {
          item.testPaperQuestionsList.forEach((data) => {
            if (data.questionId === Number(val.substring(0, val.length - 1))) {
              if (val === data.questionId + "0") {
                data.makeAnswer = true;
              } else if (val === data.questionId + "1") {
                data.makeAnswer = false;
              }

            }
          })
        });


      }
    },
    methods: {
      ...mapMutations(moduleId, ['SET_QUESTION_DATA', 'SHOW_OPTIONS', 'SET_PAPER_LIST', 'SAVE_ANSWER_SUCCESS', 'SAVE_PRE_ANSWER', 'SET_LEFT_DATA']),
      ...mapActions(moduleId, ['selectTest', 'preAnswer']),
      setQuestion(item, id, paperList, index, questionId) {
        this.num = id;
        this.activeData = item;
        //当前试题数据
        this.SET_QUESTION_DATA(item);
        this.switchData.data.forEach((data, index) => {
          if (data.questionId === item.questionId) {
            this.switchData.index = index;
          }
        });
        this.SET_PAPER_LIST(this.switchData);

        //回显上次选择答案

        //上次选择的答案
        let obj = {
          "paperId": this.$route.query.paperId,
          "questionId": questionId,
          "userId": sessionStorage.getItem('userId'),
          "classId": this.$route.query.classId,
          "examPaperId": this.examPaperId
        };
        this.SAVE_PRE_ANSWER(null)
        this.preAnswer(obj).then((result) => {
          if (result.code === "0") {
            if (result.data.answer !== "") {
              this.leftData.forEach((item) => {
                item.testPaperQuestionsList.forEach((data) => {
                  if (data.questionId === obj.questionId) {
                    data.selected = true;
                  }
                })
              });
            }
            this.$emit('getITAnswer', result.data.answer)
            this.$forceUpdate();
          }
        });
        // that.SAVE_PRE_ANSWER(null);
        // let that = this;
        // setTimeout(()=>{
        //   that.SAVE_PRE_ANSWER(null);
        //   that.answer.forEach((item)=>{
        //     if(item.questionId === questionId){
        //       that.SAVE_PRE_ANSWER(item.userAnswer);
        //     }
        //   })
        // },500)


      }

    },

    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .exam_left {
    width: 270px;
    /*flex: 1;*/
    height: 100%;
    box-sizing: border-box;
    padding: 15px;

    .left_wrap {
      width: 100%;
      height: 100%;
      background: white;
      position: relative;
      overflow: hidden;
      background: rgba(238, 238, 238, 1);

      .topic_wrap {
        width: 100%;

        .topic_num {
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #aaa;
          background: #ccc;
          border-radius: 50%;
          opacity: 1;
          color: #666;
          font-size: 12px;
          float: left;
          margin-left: 10px;
          margin-top: 8px;
          margin-bottom: 8px;
          cursor: pointer;

          &:hover {
            background: rgba(83, 151, 247, 1);
            color: white;
          }
        }

        .active {
          background: rgba(83, 151, 247, 1) !important;
          color: white !important;
        }

        .select {
          border: 1px solid rgba(83, 151, 247, 0.7);
          color: #fff;
          background: rgba(83, 151, 247, 0.7);
        }

        .makeAnswer {
          background: #FEBE2F;
          border: 1px solid #FEBE2F;
          color: white;
        }
      }

      .left_footer {
        width: 240px;
        height: 30px;
        /*position: absolute;*/
        /*left:15px;*/
        /*bottom:15px;*/
        background: rgba(255, 255, 255, 1);
        opacity: 1;
        border-radius: 3px;
        display: flex;

        div {
          flex: 1;
        }

        .not_do {
          p:nth-child(1) {
            width: 8px;
            height: 8px;
            background: rgba(204, 204, 204, 1);
            border-radius: 50%;
            opacity: 1;
            text-align: center;
            border: 1px solid rgba(204, 204, 204, 1);
            color: rgba(170, 170, 170, 1);
            margin-top: 8px;
            margin-left: 8px;
            float: left;
          }

          p:nth-child(2) {
            text-align: center;
            float: left;
            margin-top: 6px;
            font-size: 10px;
            margin-left: 3px;
          }
        }

        .do {
          p:nth-child(1) {
            width: 8px;
            height: 8px;
            background: rgba(83, 151, 247, 0.7);
            border: 1px solid rgba(83, 151, 247, 0.7);
            border-radius: 50%;
            opacity: 1;
            text-align: center;
            color: rgba(83, 151, 247, 1);
            margin-top: 8px;
            margin-left: 8px;
            float: left;
          }

          p:nth-child(2) {
            text-align: center;
            margin-top: 6px;
            float: left;
            font-size: 10px;
            margin-left: 3px;
          }
        }

        .current {
          p:nth-child(1) {
            width: 8px;
            height: 8px;
            background: rgba(83, 151, 247, 1);
            border: 1px solid rgba(83, 151, 247, 1);
            border-radius: 50%;
            opacity: 1;
            color: white;
            margin-top: 8px;
            margin-left: 8px;
            float: left;
          }

          p:nth-child(2) {
            text-align: center;
            margin-top: 6px;
            float: left;
            font-size: 10px;
            margin-left: 3px;
          }
        }

        .select {
          p:nth-child(1) {
            width: 8px;
            height: 8px;
            background: rgba(255, 189, 45, 1);
            border: 1px solid rgba(255, 189, 45, 1);
            border-radius: 50%;
            opacity: 1;
            color: rgba(255, 190, 47, 1);
            margin-top: 8px;
            margin-left: 8px;
            float: left;
          }

          p:nth-child(2) {
            text-align: center;
            margin-top: 6px;
            margin-left: 3px;
            float: left;
            font-size: 10px;
          }
        }
      }

      .student-information {
        width: 240px;
        height: 120px;
        background: rgba(255, 255, 255, 1);
        position: absolute;
        left: 0;
        bottom: 0;

        h1 {
          color: rgba(83, 151, 247, 1);
          font-size: 14px;
          margin-top: 9px;
          margin-left: 15px;
        }

        .student_item {
          width: 100%;
          height: 90px;
          margin-top: 9px;

          img {
            width: 70px;
            height: 85px;
            float: left;
            margin-left: 15px;
          }

          .student_list {
            float: left;
            margin-left: 14px;

            .student_number span:nth-child(1) {
              font-size: 14px;
              color: rgba(153, 153, 153, 1);
            }

            .student_number span:nth-child(2) {
              font-size: 14px;
              color: rgba(51, 51, 51, 1);
            }
          }
        }

        h2 {
          margin-top: 17px;

          .h_left {
            font-size: 14px;
            color: rgba(153, 153, 153, 1);
            margin-left: 15px;
          }

          .h_right {
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
          }
        }
      }

      /deep/ .el-collapse-item__header {
        width: auto;
        height: 34px;
        background: rgba(83, 151, 247, 1);
        border-radius: 4px 4px 4px 4px;
        position: relative;
        margin-bottom: 8px;
        border-left: 2px solid rgba(83, 151, 247, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        padding-left: 12px;
        line-height: 34px;
        height: 34px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      /deep/ .el-icon-arrow-right:before {
        color: rgba(255, 255, 255, 1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testComponent/examLeft.vue